import {createAction} from '@reduxjs/toolkit';

import {
  DRAWERS,
  TOURS,
  TOUR_GEOJSON,
  TOUR_SEARCH_DATES,
  TOUR_STAGES,
  UI_MODES,
} from '@explorer/constants';
import {clearActiveFolder} from '@explorer/actions/folders';
import {defineGeometry, setDateRanges} from '@explorer/actions/search';
import {setMode, showLeftDrawer} from './ui.js';

export const setTour = createAction('SET_TOUR');
export const runTour = createAction('RUN_TOUR');
export const resetTour = createAction('RESET_TOUR');

export const startTour = tour => dispatch => {
  if (!tour || tour === TOURS.MAIN) {
    dispatch(showLeftDrawer(''));
    dispatch(clearActiveFolder());
  }
  setTimeout(() => {
    dispatch(setTour(tour));
  }, 200);
};

export const endTour = tour => dispatch => {
  dispatch(resetTour(tour));
};

export const setTourIndex = createAction('SET_TOUR_INDEX');

export const setupTourStage = stageIndex => (dispatch, getState) => {
  const state = getState();
  const steps = state.tour.steps;
  const stageId = steps[stageIndex] && steps[stageIndex].id;

  //Puppet MASTER!
  switch (stageId) {
    case TOUR_STAGES.ORDERS_SIDEBAR:
      dispatch(showLeftDrawer(''));
      break;
    case TOUR_STAGES.FOLDERS_SIDEBAR:
      dispatch(showLeftDrawer(''));
      break;
    case TOUR_STAGES.SEARCH_INPUT:
      dispatch(showLeftDrawer(''));
      break;
    case TOUR_STAGES.TIMELINE:
      dispatch(clearActiveFolder());
      break;

    case TOUR_STAGES.SEARCH_SIDEBAR:
      dispatch(showLeftDrawer(DRAWERS.SEARCH));
      dispatch(setDateRanges([TOUR_SEARCH_DATES]));
      dispatch(defineGeometry({geometry: TOUR_GEOJSON.features[0].geometry}));
      break;
    case TOUR_STAGES.FILTERS:
      dispatch(showLeftDrawer(DRAWERS.SEARCH));
      break;

    case TOUR_STAGES.ORDER_BUTTON:
      dispatch(showLeftDrawer(DRAWERS.SEARCH));
      break;
    case TOUR_STAGES.COMPARE:
      dispatch(setMode(UI_MODES.COMPARE));
      break;

    default:
      // do nothing
      dispatch(setMode(UI_MODES.BROWSE));
  }

  dispatch(setTourIndex(stageIndex));
};
